import React, { useState, useEffect } from 'react';
import { diglettSpriteSheet } from '../../../constants/items';

const DiglettSprite = ({ 
  position = 0, 
  lane = 0, 
  isPlayer = false, 
  animationState = 'underground',
  trackWidth = 800,
  trackHeight = 400 
}) => {
  const [visualOffset, setVisualOffset] = useState({ x: 0, y: 0 });
  const [currentFrame, setCurrentFrame] = useState(0);

  // Sprite sheet dimensions: 126x20, each frame 18x20
  const SPRITE_SHEET_WIDTH = 126;
  const SPRITE_SHEET_HEIGHT = 20;
  const FRAME_WIDTH = 18;
  const FRAME_HEIGHT = 20;
  const TOTAL_FRAMES = 7; // 126 / 18 = 7 frames

  // Calculate position based on progress (0-100%) - moving vertically up the track
  // All players on single track, spread horizontally by lane offset
  const displayWidth = trackWidth * 4; // Match the scaled display width
  const laneOffset = lane * 20; // Small horizontal offset for each racer
  const xPosition = (displayWidth / 2) - (FRAME_WIDTH / 2) + laneOffset - 40; // Center with lane offset
  const yPosition = trackHeight - (position / 100) * (trackHeight - FRAME_HEIGHT) - FRAME_HEIGHT;

  // Get sprite frame based on animation state and position
  const getSpriteFrame = () => {
    if (position >= 95) {
      // At the end of race, show the final frame (Diglett popped up)
      return TOTAL_FRAMES - 1; // Frame 6 (last frame)
    } else {
      // During race, cycle through underground movement frames
      switch(animationState) {
        case 'underground': return Math.floor(currentFrame / 2) % 5; // Frames 0-4
        case 'emerging': return 5; // Frame 5
        case 'surface': return 6; // Frame 6 (final frame)
        case 'diving': return 4; // Frame 4
        default: return Math.floor(currentFrame / 2) % 5;
      }
    }
  };

  // Animation frame cycling
  useEffect(() => {
    const frameInterval = setInterval(() => {
      setCurrentFrame(prev => (prev + 1) % 20); // Cycle every 20 frames
    }, 150); // Update every 150ms

    return () => clearInterval(frameInterval);
  }, []);

  // Calculate visual effects based on animation state
  useEffect(() => {
    const yOffset = {
      'underground': 5,
      'emerging': -2,
      'surface': -8,
      'diving': 2
    }[animationState] || 0;

    setVisualOffset({ x: 0, y: yOffset });
  }, [animationState]);

  const frameIndex = getSpriteFrame();
  const backgroundPositionX = -(frameIndex * FRAME_WIDTH);

  return (
    <div
      className={`diglett-sprite ${isPlayer ? 'player' : 'npc'}`}
      style={{
        position: 'absolute',
        left: `${xPosition + visualOffset.x}px`,
        top: `${yPosition + visualOffset.y}px`,
        width: `${FRAME_WIDTH}px`,
        height: `${FRAME_HEIGHT}px`,
        zIndex: position >= 95 ? 10 : 5,
        transition: 'left 0.1s ease-out, top 0.1s ease-out',
        filter: isPlayer ? 'drop-shadow(0 0 4px #ffff00)' : 'none',
        backgroundImage: `url(${diglettSpriteSheet})`,
        backgroundPosition: `${backgroundPositionX}px 0px`,
        backgroundSize: `${SPRITE_SHEET_WIDTH}px ${SPRITE_SHEET_HEIGHT}px`,
        backgroundRepeat: 'no-repeat',
        imageRendering: 'pixelated'
      }}
    >
      {/* Player indicator */}
      {isPlayer && (
        <div style={{
          position: 'absolute',
          top: '-20px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '10px',
          fontWeight: 'bold',
          color: '#ffff00',
          textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
          whiteSpace: 'nowrap'
        }}>
          YOU
        </div>
      )}
    </div>
  );
};

export default DiglettSprite;